import { Report1912Container } from "../../../containers/borrowSystem/Report/Report1912Container";

export function Report1912Page() {
    return (
        <Report1912Container />
    )
}